// extracted by mini-css-extract-plugin
export default {"item":"NewsBannersSkelleton_item__bnmbI","image":"NewsBannersSkelleton_image__lQaoE","title":"NewsBannersSkelleton_title__1wzLd"};